import { createSelector } from 'reselect';
import { getSelectedElement, getIsModuleInlineEditable } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { BUILTIN_FOOTER, BUILTIN_WEBVERSION, ELEMENT, INBOX, TAB_SEND_OPTIONS, TAB_ADD, TAB_CONTENT, TAB_DESIGN, TAB_AUTOMATE, TAB_SCHEDULE, TAB_SETUP } from 'EmailEditorUI/constants/SidebarConstants';
import { getCanUseFlexAreas } from 'EmailEditorUI/redux/selectors/templateInfoSelectors';
import { getIsEmailTemplate, getIsCustomEmail, getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getSidebarOpen, getSelectedType, getCurrentSidebarTab, getSelectedId, getIsElementOrSectionSelected } from 'EmailEditorUI/redux/selectors/selected';
import { getIsScheduleTabAvailable, getIsAutomateTabAvailable } from 'EmailEditorUI/redux/selectors/AppStateSelectors';

// @ts-expect-error Internal helper using any for state
const getShouldOpenSidebarForSelectedElement = state => {
  const selectedElement = getSelectedElement(state);
  if (!selectedElement) {
    return false;
  }
  const isElementInline = getIsModuleInlineEditable(state, selectedElement.get('module_id'), selectedElement);
  return !isElementInline;
};
export const getIsSidebarOpened = createSelector([getSidebarOpen, getSelectedType, getShouldOpenSidebarForSelectedElement], (isSidebarOpen, selectedType, shouldOpenSidebarForSelectedElement) => {
  if (selectedType !== ELEMENT) {
    return isSidebarOpen || selectedType === BUILTIN_FOOTER || selectedType === BUILTIN_WEBVERSION;
  }
  return isSidebarOpen || shouldOpenSidebarForSelectedElement;
});
export const getCanDisplayContentTreeSidebar = createSelector([getIsEmailTemplate], isEmailTemplateEditor => {
  return !isEmailTemplateEditor;
});
export const getIsInboxContentSectionOpen = createSelector([getSelectedId], selectedId => {
  return selectedId === INBOX;
});
export const getIsSendOptionsTabOpened = createSelector([getSidebarOpen, getCurrentSidebarTab, getSelectedId, getIsElementOrSectionSelected], (isSidebarOpen, currentSidebarTab, selectedId, isElementOrSectionSelected) => {
  return isSidebarOpen && currentSidebarTab === TAB_SEND_OPTIONS && !isElementOrSectionSelected || selectedId === TAB_SEND_OPTIONS;
});
export const getTabsForSidebar = createSelector([getIsEmailTemplate, getIsCustomEmail, getCanUseFlexAreas, getIsScheduleTabAvailable, getIsAutomateTabAvailable, getIsDragDropEmail], (isEmailTemplateEditor, isCustomEmail, canUseFlexAreas, isScheduleTabAvailable, isAutomateTabAvailable, isDragDropEmailCategory) => {
  if (isCustomEmail) {
    const tabs = [TAB_CONTENT, TAB_DESIGN];
    if (canUseFlexAreas) {
      tabs.unshift(TAB_ADD);
    }
    tabs.push(TAB_SEND_OPTIONS);
    tabs.push(TAB_SETUP);
    if (isAutomateTabAvailable) {
      tabs.push(TAB_AUTOMATE);
    }
    if (isScheduleTabAvailable) {
      tabs.push(TAB_SCHEDULE);
    }
    return tabs;
  } else if (isDragDropEmailCategory && !isEmailTemplateEditor) {
    const tabs = [TAB_ADD, TAB_CONTENT, TAB_DESIGN];
    tabs.push(TAB_SEND_OPTIONS);
    tabs.push(TAB_SETUP);
    if (isAutomateTabAvailable) {
      tabs.push(TAB_AUTOMATE);
    }
    if (isScheduleTabAvailable) {
      tabs.push(TAB_SCHEDULE);
    }
    return tabs;
  } else {
    // AB test is not supported in email template editor
    return [TAB_ADD, TAB_DESIGN];
  }
});